import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, appendMetadata = true): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName, appendMetadata);
  }

  public exportAsCSVFile(json: any[], fileName: string): void {
    const replacer = (key: any, value: any) => (value === null ? '' : value);
    const header = Object.keys(json[0]);
  
    const csv = [
      header.join(','),
      ...json.map(row =>
        header.map(fieldName => 
          JSON.stringify(row[fieldName], replacer)
        ).join(',')
      )
    ].join('\r\n');
  
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName + '.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private saveAsExcelFile(buffer: any, fileName: string, appendMetadata = true): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    if (appendMetadata) {
      fileName = fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION;
    } else {
      fileName = fileName + EXCEL_EXTENSION;
    }
    FileSaver.saveAs(data, fileName);
  }

  public saveAsFile(filename: string, ext: string, content: string) {
    const blob = new Blob([content], {type: 'text/plain;charset=utf-8'});
    FileSaver.saveAs(blob, `${filename}.${ext}`);
    return true;
  }
}
